export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_12.60acdb03.jpg";